<div [className]="embed?.className" [ngStyle]="getEmbedStyles()">
  @if (embed?.title) {
    <h3>{{ embed.title }}</h3>
  }
  <div class="w-100" [ngStyle]="{ height: $safeNavigationMigration(embed?.height) }">
    <ag-iframe [url]="$safeNavigationMigration(embed?.targetUrl)"></ag-iframe>
  </div>
</div>
